import { useEffect, useState } from "react";

const fallbackL2List = ["Catalan (Central)", "Spanish (Castilian)", "Italian", "Greek", "Norwegian", "English"];

const CategoryDropdownL2 = ({ selectHandler, elValue}) => {
    const [L2List, setList] = useState([]);

    useEffect(() => {
        const controller = new AbortController();

        const fetchL2List = async () => {
            try {
                const resp = await fetch(`${process.env.REACT_APP_USER_API_URL}/exercises/l2list`, {
                    signal: controller.signal
                });

                if (!resp.ok) {
                    setList(fallbackL2List);
                    return;
                }

                const json = await resp.json();
                setList(Array.isArray(json) ? json : fallbackL2List);
            } catch (error) {
                if (error.name !== "AbortError") {
                    setList(fallbackL2List);
                }
            }
        }

        fetchL2List();

        return () => {
            controller.abort();
        }
    }, []);

    return <select value={elValue} 
        name="l2" 
        id="l2" 
        className="min-w-[12rem] px-3 py-2 text-sm font-semibold"
        onChange={selectHandler}
    >
        {L2List.map(les => <option value={les} key={les}>
            {les}
        </option>)}
    </select>
};

export default CategoryDropdownL2;
